
function countdown_to(el) {
  let opts;
  let interval;
  // let start_timestamp = null;
  let target_date;

  // Convert units into milliseconds
  const second_as_ms = 1000;
  const minute_as_ms = second_as_ms * 60;
  const hour_as_ms = minute_as_ms * 60;
  const day_as_ms = hour_as_ms * 24;

  function item_settings() {
    opts = {
      target_unix_time: null,
      start_time: null,
      days_label: 'Days',
      hours_label: 'Hours',
      minutes_label: 'Minutes',
      seconds_label: 'Seconds',
    };
    function set_opt(attr, opt_name) {
      if (el.hasAttribute(attr)) {
        opts[opt_name] = el.getAttribute(attr);
      }
    }
    set_opt('data-js-countdown-to-target-unix-time', 'target_unix_time');
    set_opt('data-js-countdown-to-start-time', 'start_time');
    set_opt('data-js-countdown-to-days-label', 'days_label');
    set_opt('data-js-countdown-to-hours-label', 'hours_label');
    set_opt('data-js-countdown-to-minutes-label', 'minutes_label');
    set_opt('data-js-countdown-to-seconds-label', 'seconds_label');
  }

  function countdown() {
    const now = new Date();
    const time_remaining = target_date - now;

    if (time_remaining <= 0) {
      clearInterval(interval);
      document.getElementById('countdown').innerHTML = '0.00';
      return;
    }

    // These are the printable numbers
    const days = Math.floor(time_remaining / day_as_ms);
    const hours = Math.floor((time_remaining % day_as_ms) / hour_as_ms);
    const minutes = Math.floor((time_remaining % hour_as_ms) / minute_as_ms);
    const seconds = Math.floor((time_remaining % minute_as_ms) / second_as_ms);

    const countdown_string = `
      ${days} ${opts.days_label} |
      ${hours} ${opts.hours_label} |
      ${minutes} ${opts.minutes_label} |
      ${seconds < 10 ? '0' : ''}${seconds} ${opts.seconds_label}
    `;

    el.innerHTML = countdown_string;
  }

  function init_item() {
    item_settings();

    if (!opts.target_unix_time) {
      return;
    }

    if (!opts.start_time) {
      opts.start_time = null; // current time
    }

    target_date = new Date(opts.target_unix_time * 1000);
    interval = setInterval(countdown, 1000);
  }
  init_item();
}

// init_all
// ------------------------------------

function init_all() {
  const items = Array.from(document.querySelectorAll('[data-js-countdown-to]'));
  items.forEach(countdown_to);
}
init_all();
